export enum DefaultImages {
  Hero = "https://img.ifit.com/default-images/hero.jpg",
  CSVPostWorkoutBackgroundIntervals = "https://img.ifit.com/default-images/csv_post_workout_background_intervals.jpg",
  CSVPostWorkoutBackgroundIntervals2x = "https://img.ifit.com/default-images/csv_post_workout_background_intervals2x.jpg",
  CSVPostWorkoutBackgroundIntervals3x = "https://img.ifit.com/default-images/csv_post_workout_background_intervals3x.jpg",
  CSVWorkoutDetailsBackgroundIntervals = "https://img.ifit.com/default-images/csv_workout_details_background_intervals.jpg",
  CSVWorkoutDetailsBackgroundIntervals2x = "https://img.ifit.com/default-images/csv_workout_details_background_intervals2x.jpg",
  CSVWorkoutDetailsBackgroundIntervals3x = "https://img.ifit.com/default-images/csv_workout_details_background_intervals3x.jpg",
  DefaultTrainerProfile = "https://img.ifit.com/default-images/default_trainer_profile.jpg",
  LargeCard = "https://img.ifit.com/default-images/large-card.jpg",
  PostMap = "https://img.ifit.com/default-images/post_map_img.jpg",
  PostMap2x = "https://img.ifit.com/default-images/post_map_img@2x.png",
  PostMap3x = "https://img.ifit.com/default-images/post_map_img@3x.png",
  PostTrainer = "https://img.ifit.com/default-images/post_trainer_img.jpg",
  PostTrainer2x = "https://img.ifit.com/default-images/post_trainer_img@2x.png",
  PostTrainer3x = "https://img.ifit.com/default-images/post_trainer_img@3x.png",
  PreMap = "https://img.ifit.com/default-images/pre_map_img.jpg",
  PreMap2x = "https://img.ifit.com/default-images/pre_map_img@2x.jpg",
  PreMap3x = "https://img.ifit.com/default-images/pre_map_img@3x.jpg",
  PreTrainer = "https://img.ifit.com/default-images/pre_trainer_img.jpg",
  PreTrainer2x = "https://img.ifit.com/default-images/pre_trainer_img@2x.jpg",
  PreTrainer3x = "https://img.ifit.com/default-images/pre_trainer_img@3x.jpg",
  Source = "https://img.ifit.com/default-images/source.jpg",
  Thumbnail = "https://img.ifit.com/default-images/thumbnail.jpg",
  WebBanner = "https://img.ifit.com/default-images/web-banner.jpg"
}
